// extracted by mini-css-extract-plugin
export default {"weatherAndMap":"cityinfo_weatherAndMap__xYM-a"};